import { service } from '@ember/service';
import Component from '@glimmer/component';
import ContactModel, {
  type ContactCustomProperty,
} from 'donor-elf-web/models/contact';
import ContactsCache from 'donor-elf-web/services/contacts-cache';

interface ComponentArgs {
  contact: ContactModel;
}

export default class ContactMobileMoreInfoComponent extends Component<ComponentArgs> {
  @service declare contactsCache: ContactsCache;

  get sortedCustomProperties() {
    let propertiesByLabel = this.args.contact.customPropertiesByLabel;
    let list: ContactCustomProperty[] = [];
    for (let prop of this.contactsCache.customProperties) {
      if (propertiesByLabel[prop.l]) {
        list.push(propertiesByLabel[prop.l]);
      }
    }
    return list;
  }
}
